import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

const useStyles = makeStyles({
    menuButton: {
      color: '#273090',
        '&:hover': {
          color: '#F9AF44'
        }
    },
    root: {
      paddingRight:20,
      paddingTop:5,
      color: '#666',

    }
  });

export default function LoggedInPaper(props) {
  const classes = useStyles();
  const [state] = useContext(SessionContext);
  const [uState, udispatch] = useContext(UserContext);
  const [data, setData] = useState({});
  const [username, setUsername] = useState('');
  const [accountid, setAccountid] = useState(0);
  //const [balance, setBalance] = useState(10.00);
  

  useEffect(() => {

      const abortController = new AbortController();
      const request = {   
        ident:state.ident,
        userid:state.userid,
      };
      //console.log("requestJSON:"+JSON.stringify(request));
      let mounted = true;
      (async () => {

        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/detail', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const rdata = await res.json();
        if (mounted) {
          if (rdata.status === "success"){
            setData(rdata);
            udispatch({
            type: "create",
            payload: { 
              userid: rdata.user.userid,
              companyid: rdata.company.companyid,
              user: rdata.user,
              company: rdata.company,
              default: rdata.defaults,
            }
          });

          if (rdata.company.companytype === 'training'){
            setUsername('Welcome'); 
            setAccountid('Training mode');
          } else {
            setUsername('Welcome '+rdata.user.username); 
            setAccountid('Account ID: '+rdata.company.findid)
          }

        } else {

        }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
    
  }, [udispatch, state.userid, state.ident]);

//<Box fontWeight="fontWeightBold" fontSize={12}>Balance: £ {balance}</Box>
  return (
    <div className={classes.root}>
      <Box fontWeight="fontWeightBold" fontSize={14}>{username}</Box>
      <Box fontWeight="fontWeightBold" fontSize={14}>{accountid}</Box>
    </div>
  );
}
